import HistoryUtil from 'common/util/HistoryUtil';
import './product-tabs.scss';

export default () => Component(function ($context) {
	return $context.select('.product-tabs');
}, function ($tabs, self) {
	$.extend(self, {
		initEventListeners: function () {
			if ($tabs.hasClass('product-tabs_links')) {
				return;
			}

			$tabs.on('click', '.product-tabs__tab', function () {
				const $tabs = self.getTabs();
				const $tab = $(this);
				const index = $tabs.index($tab);
				self.selectTab($tabs.index($tab));

				if (ResponsiveUtil.isToTablet()) {
					self.scrollTo(index);
					self.changeSlide(index);
				}

			});

			$(document).on('click', 'a', function () {
				if (!ResponsiveUtil.isDesktopUp()) {
					return;
				}

				if (this.toString() !== window.location.toString() || !this.hash) {
					return;
				}

				const index = self.getTabBySlug(this.hash.substr(1));

				if (index === -1) {
					return;
				}

				self.selectTab(index);
				self.scrollTo(index);
			});

			$(window).on('hashchange', function () {
				if (!window.location.hash) {
					return;
				}

				const index = self.getTabBySlug(window.location.hash.substr(1));

				if (index === -1) {
					return;
				}

				self.selectTab(index);
				self.changeSlide(index);
				self.scrollTo(index);
			});
		},
		initTabs: function () {
			self.getTabs().each(function (index) {
				const $tab = $(this);

				if (window.location.hash === '#' + $tab.data('slug')) {
					if (index !== 0) {
						self.selectTab(index);
						self.changeSlide(index);
					}

					self.scrollTo(index);

					return false;
				}
			});
		},
		selectTab: function (index) {
			if (self.getIndex() === index) {
				return;
			}

			const $all_tabs = self.getTabs();
			const $contentBlocks = self.getContentBlocks();
			const $tab = $all_tabs.eq(index);
			const $contentBlock = $contentBlocks.eq(index);

			const slug = $tab.data('slug') || '';

			if (slug) {
				if (index === 0) {
					HistoryUtil.replaceState(null, null, window.location.pathname);
				} else {
					HistoryUtil.replaceState(null, null, '#' + slug);
				}
			}

			$all_tabs.removeClass('product-tabs__tab_selected');
			$contentBlocks.removeClass('product-tabs__block_selected');
			$tab.addClass('product-tabs__tab_selected');
			$contentBlock.addClass('product-tabs__block_selected');

			$tabs.trigger('select_tab');
		},
		getTabBySlug: function (slug) {
			let result = -1;

			self.getTabs().each(function (index) {
				const $tab = $(this);
				const content_slug = $tab.data('slug') || '';

				if (slug === content_slug) {
					result = index;
					return false;
				}
			});

			return result;
		},
		getIndex: function () {
			return self.getTabs().filter('.product-tabs__tab_selected').index();
		},
		scrollTo: function (index) {
			HistoryUtil.disableScrollRestoration();
			const $tab = self.getTabs().eq(index);
			const scroll_top = $tab.offset().top;
			let offset = 70;
			const $floatingHeader = $('.header__floating');

			if ($floatingHeader.length > 0) {
				offset = $floatingHeader.outerHeight();
			}

			ScrollUtil.scrollTo(scroll_top - offset);
		},
		getTabs: function () {
			return $tabs.find('.product-tabs__tab');
		},
		getContentBlocks: function () {
			return $tabs.find('.product-tabs__block');
		},
		initSlider: function() {
			const $tabsBlock = $tabs.find('.product-tabs__tabs');

			if ($tabsBlock.width() > $tabs.width()) {
				const $tabsBlockWrapper = $tabsBlock.closest('.product-tabs__tabs-wrapper');
				const $tabs = self.getTabs();
				const initialSlide = $tabs.index($tabs.filter('.product-tabs__tab_selected'))

				const swiper = new Swiper($tabsBlockWrapper.get(0), {
					wrapperClass: 'product-tabs__tabs',
					slideClass: 'product-tabs__tab',
					slidesPerView: 'auto',
					initialSlide: initialSlide,
					loop: false,
					spaceBetween: 0
				});
			}
		},
		changeSlide: function(index) {
			const $tabsBlockWrapper = $tabs.find('.product-tabs__tabs-wrapper');
			const tabsSwiper = $tabsBlockWrapper.get(0).swiper;
			if (!tabsSwiper) {
				return;
			}

			tabsSwiper.slideTo(index);
		}
	});

	console.log('tabs');
	self.initEventListeners();
	self.initTabs();
	self.initSlider();
});
